import script from "./CardRenderer.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardRenderer.vue?vue&type=script&lang=ts&setup=true"

import "./CardRenderer.vue?vue&type=style&index=0&id=62e22b78&lang=scss"

const __exports__ = script;

export default __exports__